import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { Logo } from './Logo';
import { footerColumns, paymentMethods } from '../../data/navigation';
export function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'error' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setStatus('error');
      return;
    }
    setStatus('success');
    setEmail('');
  };
  return <footer className="bg-ink text-white" data-id="element-223" data-mp="3n3k9g59palpv">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8" data-id="element-224" data-mp="3n4lvt5w62umw">
        <div className="grid gap-10 lg:grid-cols-12" data-id="element-225" data-mp="3j28tkrgmpeuv">
          <div className="lg:col-span-4" data-id="element-226" data-mp="3j3toii6uuzt9">
            <Logo inverted data-id="element-227" data-mp="3e2mesdl5jqjy" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/60" data-id="element-228" data-mp="3e1ujl3vgvuu7">
              Thuisbatterijen, powerstations en zonnepanelen voor particulieren en bedrijven in Nederland en België.
            </p>
            <form onSubmit={handleSubmit} className="mt-6 max-w-sm" noValidate data-id="element-229" data-mp="2kbjsf4joxzeg">
              <label htmlFor="newsletter" className="text-sm font-semibold" data-id="element-230" data-mp="2p4v1lcbz6s9j">
                Aanbiedingen &amp; nieuwe producten in je inbox
              </label>
              <div className="mt-2 flex gap-2" data-id="element-231" data-mp="2gbj50uem6dv9">
                <input id="newsletter" type="email" value={email} onChange={e => {
                setEmail(e.target.value);
                setStatus('idle');
              }} placeholder="jij@email.nl" aria-invalid={status === 'error'} aria-describedby="newsletter-status" className="h-11 min-w-0 flex-1 rounded-lg border border-white/15 bg-ink-soft px-3.5 text-sm text-white placeholder:text-white/40 focus:border-volt focus:outline-none" data-id="element-232" data-mp="2gcb0844au9l0" />
                <button type="submit" className="h-11 shrink-0 rounded-lg bg-volt px-4 text-sm font-semibold text-ink transition-colors duration-150 hover:bg-volt-hover" data-id="element-233" data-mp="1no5fvih5qmlp">
                  Aanmelden
                </button>
              </div>
              <p id="newsletter-status" className="mt-2 min-h-[1.25rem] text-xs" aria-live="polite" data-id="element-234" data-mp="uql38uv5ycj2">
                {status === 'error' && <span className="text-red-300" data-id="element-235" data-mp="pri57udlp6kl">Vul een geldig e-mailadres in.</span>}
                {status === 'success' && <span className="inline-flex items-center gap-1 text-volt" data-id="element-236" data-mp="fun89fwz7e8f">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-237" data-mp="btjs0sb0ng6o" /> Je bent aangemeld.
                  </span>}
              </p>
            </form>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-8 lg:pl-10" data-id="element-238" data-mp="6wth0je2jas4">
            {footerColumns.map(col => <div key={col.title} data-id="element-239" data-mp="21886r072xa7v">
                <h3 className="text-sm font-semibold" data-id="element-240" data-mp="2199jd93qu4rp">{col.title}</h3>
                <ul className="mt-4 space-y-2.5" data-id="element-241" data-mp="28qzchbqlfsez">
                  {col.links.map(l => <li key={l.label} data-id="element-242" data-mp="2dqbxdqxwmpex">
                      <Link to={l.href} className="text-sm text-white/60 transition-colors duration-150 hover:text-white" data-id="element-243" data-mp="2dp94xekxoeww">
                        {l.label}
                      </Link>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-white/10 pt-6 md:flex-row md:items-center md:justify-between" data-id="element-244" data-mp="1pvhltbz4xta6">
          <ul className="flex flex-wrap gap-2" aria-label="Betaalmethoden" data-id="element-245" data-mp="1zqt3a21xhelm">
            {paymentMethods.map(m => <li key={m} className="rounded-md bg-white px-2.5 py-1 text-xs font-bold text-ink" data-id="element-246" data-mp="23tz4gva6ofl8">
                {m}
              </li>)}
          </ul>
          <p className="text-xs text-white/50" data-id="element-247" data-mp="3f830s848uftg">© 2026 Ampra Energy B.V. · KvK 81234567 · Prijzen incl. btw</p>
        </div>
      </div>
    </footer>;
}